
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Montreuil dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Montreuil certifiée Google Partner, accompagne les entreprises montreuilloises pour booster leur notoriété en ligne et attirer de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Montreuil dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Montreuil certifiée Google Partner, accompagne les entreprises montreuilloises pour booster leur notoriété en ligne et attirer de nouveaux clients.",
        },
      ],
    };
  },
};
